import styled from "styled-components"

export const Toggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.75rem;
  padding: 0.25rem 0;
  background: none;
  border: 0;
  color: var(--navy);
  font-weight: 600;
  cursor: pointer;
  span {
    display: inline-flex;
    width: 1.4rem;
    height: 1.4rem;
    align-items: center;
    justify-content: center;
    border: 1.5px solid var(--navy);
    border-radius: 2px;
    font-size: 1rem;
    line-height: 1;
  }
  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 0.2em;
  }
`

export const Panel = styled.div`
  margin-top: 1.25rem;
`
